/* -------------------------------------------------------------
   Cobertura de prensa — Arteconciencia en los medios.
   Para agregar una nota, añade un objeto al array:
   {
     medio: "Nombre del medio",
     titular: "Titular de la nota",
     fecha: "2026-09-15",          // ISO, se muestra formateada
     imagen: "/brand/prensa/archivo.webp",  // opcional
     descripcion: "Breve descripción de la cobertura.",
     enlace: "https://medio.com/nota",
   }
   ------------------------------------------------------------- */

export const PRENSA = [];
